function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Tools"));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "iconic-size-md-tools-clip-0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v32h32v-32h-32zm20 21l-1 1-17-17 1-1 2-2 17 17-2 2z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 32,
  "data-height": 32
}, /*#__PURE__*/React.createElement("path", {
  className: "iconic-tools-screwdriver iconic-tools-screwdriver-head iconic-property-accent iconic-property-fill",
  d: "M4 5l16 16 1-1-16-16-1-2-3-2-1 1 2 3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 27.011l-9-9.011h-1l-1-1-3 3 1 1v1l9.011 8.989c.52.613 1.287 1.011 2.154 1.011 1.566 0 2.835-1.269 2.835-2.835 0-.867-.387-1.634-1-2.154z",
  className: "iconic-tools-screwdriver iconic-tools-screwdriver-handle iconic-property-accent iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 7c-1-1-1 0-2-1s0-1-1-2-1-1-1-1c-3-3-4-3-10-3 7 3.031 4.984 6.016 4 7l-9 9 2 2 9-9c.984-.984 1.969-1.031 3 0s0 1 1 2 1 1 1 1l4-4s0 0-1-1z",
  clipPath: "url(#iconic-size-md-tools-clip-0)",
  className: "iconic-tools-hammer iconic-tools-hammer-head iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.526 13.158l-2.051.684c-.262.087-.633.316-.828.512l-11.293 11.293c-.195.195-.253.554-.13.801l2.553 5.106c.123.247.348.261.501.032l1.46-2.184c.153-.23.436-.574.631-.769l10.277-10.277c.195-.195.423-.566.509-.829l.658-2.018c.086-.263.313-.634.509-.829l.324-.324c.195-.195.195-.512 0-.707l-1.293-1.293c-.195-.195-.512-.195-.707 0l-.293.293c-.195.195-.566.424-.828.512z",
  clipPath: "url(#iconic-size-md-tools-clip-0)",
  className: "iconic-tools-hammer iconic-tools-hammer-handle iconic-property-fill"
}));

function SvgToolsMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "tools",
    className: "iconic iconic-tools iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsMd);
export default __webpack_public_path__ + "static/media/tools-md.31fb0b2a.svg";
export { ForwardRef as ReactComponent };